import { Option } from './option';

export class OptionField extends Option<string> {
    readonly type = 'field';
}
